import React from "react";
import Text from "../Text";
import { Container, RightOuterRing, OffsetRing, LeftOuterRing } from "./styles";

const generateStyle = (percent, base_degrees) => {
	const rotateBy = base_degrees + percent * 3.6;

	return {
		transform: [{ rotateZ: `${rotateBy}deg` }],
	};
};

const renderOffsetRing = (percent) => {
	if (percent > 50) {
		return (
			<OffsetRing style={[generateStyle(percent - 50, 45)]}></OffsetRing>
		);
	} else {
		return <LeftOuterRing></LeftOuterRing>;
	}
};

const CircularProgress = ({ percent }) => {
	let rightOuterRingStyle;
	if (percent > 50) {
		rightOuterRingStyle = generateStyle(50, -135);
	} else {
		rightOuterRingStyle = generateStyle(percent, -135);
	}

	return (
		<Container>
			<RightOuterRing style={[rightOuterRingStyle]}></RightOuterRing>
			{renderOffsetRing(percent)}
			<Text type="h2">{`${percent}%`}</Text>
		</Container>
	);
};

export default CircularProgress;
